<template>
  <div id="pageRoot">
    <img id="bg" class="pageElement" src="/pages/img/sordoglo/svgGlo34bg.svg" />

    <span class="normalTheme pageInstruction" style="left: 70px; top: 138px">
      <p>Lee el texto y completa con la palabra adecuada:</p>
    </span>

    <p class="pageElement textBaseCourier" id="text03">BICHOS / ANIMALES</p>
    <p class="pageElement textBaseCourier" id="text04">CUEVAS PEQUEÑAS / CUEVITAS</p>

    <div class="book01">
      <img src="/pages/img/sordoglo/svgGlo34Book.svg" />
      <p class="textBaseCourier" id="text11">LOS HÁBITOS DE LOS SAPOS</p>
      <p class="textBaseCourier textSimple" id="text12">
        LOS SAPOS SON ____________ POR LO GENERAL NOCTURNOS.<br>DURANTE EL DIA SE OCULTAN
        EN LUGARES OSCUROS Y DURANTE LA NOCHE SE DEDICAN A LA CAZA. SU LENGUA
        PEGAJOSA LES PERMITE APRESAR INSECTOS EN PLENO VUELO. CUANDO LLEGA EL
        INVIERNO SE REFUGIAN EN _____________ ALLI SE QUEDAN ALETARGADOS HASTA LA
        LLEGADA DE LA PRIMAVERA
      </p>
      <saved-input
        v-bind:page="$parent.page"
        v-bind:type="$parent.type"
        number="1"
        id="inputField01"
        class="pageElement"
      />
      <saved-input
        v-bind:page="$parent.page"
        v-bind:type="$parent.type"
        number="2"
        id="inputField02"
        class="pageElement"
      />
    </div>
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 58px;
  top: 40px;
}
#text03 {
  position: absolute;
  width: 426px;
  height: 41px;
  left: 105px;
  top: 202px;
  font-weight: bold;
  font-size: 35px;
  line-height: 40px;
  color: #231f20;
}
#text04 {
  position: absolute;
  width: 426px;
  height: 41px;
  left: 105px;
  top: 252px;
  font-weight: bold;
  font-size: 35px;
  line-height: 40px;
  color: #231f20;
}
#text11{
  position: absolute;
  width: 342px;
  height: 150px;
  left: 315px;
  top: 88px;
  font-weight: bold;
  font-size: 46px;
  line-height: 55px;
}
#text12{
  position: absolute;
  width: 828px;
  height: 200px;
  left: 60px;
  top: 230px;
  font-size: 22px;
  line-height: 160%;
}
.book01 {
  position: absolute;
  left: 31px;
  top: 312px;
  z-index: 1;
  opacity: 0;
  animation-name: enciclopedia-appear;
  animation-duration: 0.8s;
  animation-delay: 0.3s;
  animation-timing-function: cubic-bezier(0, 0, 0.3, 1.3);
  animation-fill-mode: forwards;
}
@keyframes enciclopedia-appear {
  from {
    opacity: 0;
    top: 500px;
  }
  to {
    opacity: 1;
    top: 312px;
  }
}
#inputField01 {
  position: absolute;
  width: 155px;
  height: 25px;
  left: 237px;
  top: 220px;
  z-index: 3;
}
#inputField02 {
  position: absolute;
  width: 164px;
  height: 25px;
  left: 210px;
  top: 359px;
  z-index: 3;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "glo/Video 145.mp4",
        "glo/Video 146.mp4",
        "glo/Video 147.mp4",
        "glo/Video 148.mp4",
        ],
    };
  },
};
</script>